export const khachHang = {
  sections: {
    list: { title: 'Khách hàng' },
    general: 'Thông tin chung',
    address: 'Địa chỉ',
    groupNote: 'Nhóm khách hàng, ghi chú',
    invoiceExport: 'Thông tin xuất hóa đơn',
    extra: 'Thông tin bổ sung',
    invoice: 'Hóa đơn & thuế',
    idDocs: 'Giấy tờ',
    bank: 'Ngân hàng',
    meta: 'Thống kê',
    tabGeneral: 'Thông tin chung',
    tabDiaChiNhanHang: 'Thông tin giao hàng',
    tabThongTinXuatHoaDon: 'Thông tin xuất hóa đơn',
  },
  fields: {
    code: 'Mã KH',
    name: 'Tên khách hàng',
    phone1: 'Điện thoại 1',
    phone2: 'Điện thoại 2',
    birthday: 'Ngày sinh',
    gender: 'Giới tính',
    email: 'Email',
    facebook: 'Facebook',
    address: 'Địa chỉ',
    province: 'Tỉnh/Thành',
    area: 'Khu vực',
    ward: 'Phường/Xã',
    note: 'Ghi chú',
    customerType: 'Loại KH',
    groups: 'Nhóm KH',
    groupCode: 'Mã nhóm KH',
    groupName: 'Tên nhóm KH',
    nhanVienPhuTrach: 'NV phụ trách',
    maNhanVienPhuTrach: 'Mã NV phụ trách',
    dinhMucCongNo: 'Định mức công nợ',
    ngayCanDoiNo: 'Ngày cần đòi nợ',
    ngayDoiNoCuThe: 'Chọn ngày',
    ngayDoiNoHangThang: 'Ngày trong tháng',
    buyerName: 'Tên người mua (HĐ)',
    taxCode: 'Mã số thuế',
    invoiceAddress: 'Địa chỉ hóa đơn',
    invoiceProvince: 'Tỉnh/Thành hóa đơn',
    invoiceWard: 'Phường/Xã hóa đơn',
    invoiceEmail: 'Email hóa đơn',
    invoicePhone: 'SĐT hóa đơn',
    citizenId: 'Số CCCD',
    passport: 'Số hộ chiếu',
    bankName: 'Ngân hàng',
    bankAccount: 'Số tài khoản',
    status: 'Trạng thái',
    totalSales: 'Tổng bán',
    totalSalesNet: 'Tổng bán trừ trả hàng',
    debt: 'Nợ hiện tại',
    createdAt: 'Ngày tạo',
    updatedAt: 'Ngày cập nhật',
    actions: 'Thao tác',
  },
  aria: {
    columnPicker: 'Chọn cột hiển thị',
  },
  loai: {
    caNhan: 'Cá nhân',
    congTy: 'Tổ chức/ Hộ kinh doanh',
  },
  placeholders: {
    codeAuto: 'KH0000001',
    email: 'email@gmail.com',
    facebook: 'facebook.com/username',
    address: 'Nhập địa chỉ',
    area: 'Chọn Tỉnh/Thành phố',
    ward: 'Chọn Phường/Xã',
    groups: 'Chọn nhóm khách hàng',
    note: 'Nhập ghi chú',
    nhanVienPhuTrach: 'Chọn nhân viên phụ trách',
    maNhanVienPhuTrach: 'Nhập mã NV phụ trách',
    dinhMucCongNo: 'Để trống = không giới hạn',
    ngayCanDoiNo: 'Tới ngày này còn nợ sẽ cảnh báo đòi nợ',
    ngayDoiNoHangThang: 'Mỗi tháng tới ngày này còn nợ sẽ cảnh báo; tháng thiếu ngày lấy ngày cuối tháng',
    ngayDoiNoHangThangChon: 'Chọn ngày',
    gender: 'Chọn giới tính',
    buyerName: 'Nhập tên người mua',
    taxCode: 'Nhập mã số thuế',
  },
  avatar: {
    addPhoto: 'Thêm ảnh',
    maxSize: 'Ảnh không được vượt quá 2MB',
    chooseImage: 'Chọn ảnh',
    pasteImage: 'Dán ảnh',
    pasteHint: 'Ctrl+V trong khung hoặc bấm Paste ảnh',
    pasteNoImage: 'Clipboard không có ảnh. Hãy copy ảnh hoặc dán link http(s).',
    uploading: 'Đang tải ảnh…',
  },
  formActions: {
    lookupTax: 'Tra cứu MST',
    lookupTaxSoon: 'Chức năng tra cứu MST sẽ được bổ sung',
  },
  actions: {
    addDiaChi: 'Thêm',
    addTtxhd: 'Thêm CTY',
  },
  values: {
    khongGioiHan: 'Không giới hạn',
    chuaDat: 'Chưa đặt',
    hangThang: 'Ngày {day} hàng tháng',
    ngayTrongThang: 'Ngày {day}',
  },
  kieuHanDoiNo: {
    khong: 'Không đặt',
    hangThang: 'Hàng tháng',
    ngay: 'Ngày cụ thể',
  },
  gender: {
    nam: 'Nam',
    nu: 'Nữ',
  },
  status: {
    dangHoatDong: 'Đang hoạt động',
    ngungHoatDong: 'Ngừng hoạt động',
    all: 'Tất cả',
  },
  sort: {
    maKhachHang: 'Mã KH',
    tenKhachHang: 'Tên KH',
    ngayTao: 'Ngày tạo',
    trangThai: 'Trạng thái',
    noHienTai: 'Nợ hiện tại',
    tongBan: 'Tổng bán',
  },
  filter: {
    searchPlaceholder: 'Tìm kiếm',
    textDetailTitle: 'Bộ lọc chi tiết',
    group: 'Nhóm KH',
    statusSection: 'Trạng thái',
    groupSection: 'Nhóm khách hàng',
    loaiSection: 'Loại khách hàng',
    debtSection: 'Tình trạng công nợ',
    debtAll: 'Tất cả',
    debtOutstanding: 'Còn nợ (≠ 0)',
    debtCleared: 'Hết nợ (= 0)',
    genderSection: 'Giới tính',
    khuVucSection: 'Khu vực',
    khuVucPlaceholder: 'Khu vực (tỉnh/TP)',
    sortSection: 'Sắp xếp',
    sortField: 'Trường sắp xếp',
    sortDir: 'Chiều sắp xếp',
  },
  titles: { add: 'Thêm khách hàng', edit: 'Sửa khách hàng', detail: 'Chi tiết khách hàng' },
  validation: {
    nameRequired: 'Vui lòng nhập tên khách hàng',
    hanDoiNoRequired: 'Vui lòng chọn ngày đòi nợ',
    phoneInvalid: 'Số điện thoại không hợp lệ (8–15 chữ số)',
    emailInvalid: 'Email không hợp lệ',
    emailHoaDonInvalid: 'Email hóa đơn không hợp lệ (nhiều mail cách nhau bằng dấu ;)',
    dinhMucCongNoAm: 'Định mức công nợ không được âm',
    phoneInvalidField: '{field} không hợp lệ (8–15 chữ số)',
    birthdayInvalid: 'Ngày sinh không hợp lệ (không được ở tương lai hoặc trước năm 1900)',
    viDoInvalid: 'Vĩ độ phải trong khoảng -90 đến 90',
    kinhDoInvalid: 'Kinh độ phải trong khoảng -180 đến 180',
    taxCodeInvalid: 'Mã số thuế không hợp lệ (10 hoặc 13 chữ số)',
    companyNameRequired: 'Vui lòng nhập tên công ty lấy thuế',
    subFormInvalid: 'Thông tin giao hàng / xuất hóa đơn có ô chưa hợp lệ',
    trungSdtTitle: 'Số điện thoại đã tồn tại',
    trungSdtMessage: 'Số điện thoại {phone} đã được dùng cho: {customers}. Vẫn lưu khách hàng này?',
  },
  messages: {
    noData: 'Không có dữ liệu',
    loadError: 'Không tải được dữ liệu',
    loadDetailError: 'Không tải được chi tiết',
    createSuccess: 'Đã tạo khách hàng',
    updateSuccess: 'Đã cập nhật khách hàng',
    deleteSuccess: 'Đã xóa khách hàng',
    toggleSuccess: 'Đã đổi trạng thái',
    confirmDelete: 'Xóa khách hàng «{name}»?',
    confirmTitle: 'Xác nhận xóa',
    listSummary: 'Tổng số {count} khách hàng',
    selectedCount: 'Đã chọn: {count}',
    deleteSelected: 'Xóa đã chọn ({count})',
    bulkDeleteConfirm: 'Xóa {count} khách hàng đã chọn? (Xóa từng khách hàng qua API.)',
    bulkDeleteSuccess: 'Đã xóa {count} khách hàng',
    bulkDeletePartial: 'Đã xóa {ok}/{total}. {failed} khách hàng không xóa được.',
    bulkDeleteError: 'Xóa hàng loạt thất bại',
    bulkDeleteNoneSelected: 'Chưa chọn khách hàng nào để xóa',
  },
  import: {
    description:
      'Tải mẫu Excel nhiều sheet: Khách hàng, Thông tin giao hàng, CTY lấy thuế, Tài khoản (+ sheet tham chiếu). Điền rồi tải lên để import.',
    success: 'Import khách hàng thành công',
    failed: 'Import khách hàng thất bại',
    noData: 'File không có dòng dữ liệu hợp lệ',
    noSheet: 'File Excel không có sheet nào',
    wrongTemplate:
      'File không đúng mẫu khách hàng (ví dụ đang dùng mẫu nhập hàng hóa). Tải mẫu từ nút «Tải file mẫu» trên dialog import khách hàng, hoặc import hàng hóa ở menu Hàng hóa.',
    sheetsHint:
      'Nhập: «Khách hàng» · «Thông tin giao hàng» · «CTY lấy thuế» · «Tài khoản». Tham chiếu: Nhóm KH · NV phụ trách · Ngân hàng · Giới tính · Hướng dẫn.',
    menu: {
      kh: 'Import khách hàng',
      diaChi: 'Import thông tin giao hàng',
      cty: 'Import CTY lấy thuế',
      taiKhoan: 'Import tài khoản',
      toHop: 'Import tổ hợp (KH + giao hàng + CTY + TK)',
    },
    modes: {
      kh: {
        title: 'Import khách hàng',
        description:
          'Tải mẫu sheet «Khách hàng», điền thông tin chung rồi tải lên. Mã đã có trong dự án sẽ được cập nhật (đè); mã trống hoặc mới thì tạo mới. Không tạo địa chỉ / CTY / STK.',
        success: 'Import khách hàng thành công',
      },
      diaChi: {
        title: 'Import thông tin giao hàng',
        description:
          'Tải mẫu sheet «Thông tin giao hàng». Mã khách hàng phải đã tồn tại. Mỗi dòng = 1 địa chỉ giao hàng.',
        success: 'Import thông tin giao hàng thành công',
      },
      cty: {
        title: 'Import CTY lấy thuế',
        description:
          'Tải mẫu sheet «CTY lấy thuế». Mã khách hàng phải đã tồn tại. Mỗi dòng = 1 CTY xuất HĐ / lấy thuế (chưa gồm STK).',
        success: 'Import CTY lấy thuế thành công',
      },
      taiKhoan: {
        title: 'Import tài khoản',
        description:
          'Tải mẫu sheet «Tài khoản». Gắn STK theo MST/Tên CTY đã có trên khách hàng.',
        success: 'Import tài khoản thành công',
      },
      ctyTaiKhoan: {
        title: 'Import CTY lấy thuế + tài khoản',
        description:
          'Tải mẫu 2 sheet «CTY lấy thuế» và «Tài khoản». Mã khách hàng phải đã tồn tại. STK gắn theo MST/Tên CTY.',
        success: 'Import CTY + tài khoản thành công',
      },
      toHop: {
        title: 'Import tổ hợp',
        description:
          'Tải mẫu nhiều sheet: «Khách hàng» · «Thông tin giao hàng» · «CTY lấy thuế» · «Tài khoản» (+ sheet tham chiếu). Mã đã có thì cập nhật KH (đè); mã mới thì tạo kèm địa chỉ/CTY/STK trong file.',
        success: 'Import tổ hợp thành công',
      },
    },
  },
  detailTabs: {
    generalInfo: 'Thông tin',
    diaChiLayHang: 'Thông tin giao hàng',
    thongTinXuatHoaDon: 'Thông tin xuất hóa đơn',
    debt: 'Công nợ',
    salesReturnHistory: 'Lịch sử bán / trả hàng',
    orderHistory: 'Lịch sử đặt hàng',
  },
  expandSalesReturn: {
    hint: 'Lịch sử bán / trả hàng sẽ hiển thị tại đây.',
  },
  expandOrderHistory: {
    hint: 'Lịch sử đặt hàng sẽ hiển thị tại đây.',
  },
  expandDebt: {
    hint: 'Lịch sử giao dịch công nợ sẽ hiển thị tại đây.',
    loading: 'Đang tải công nợ…',
    loadError: 'Không tải được công nợ',
    totalDue: 'Tổng phải thu',
    totalPaid: 'Đã thanh toán',
    totalRemaining: 'Còn nợ',
    invoiceCount: '{count} hóa đơn',
    recentInvoices: 'Hóa đơn gần đây',
    viewAll: 'Xem tất cả',
    retry: 'Thử lại',
    invoiceCode: 'Mã hóa đơn',
    invoiceDate: 'Ngày',
    invoiceStatus: 'Trạng thái',
    amountDue: 'Phải thu',
    amountPaid: 'Đã trả',
    amountRemaining: 'Còn lại',
  },
}
